// extracted by mini-css-extract-plugin
module.exports = {"table":"SimpleTable_table__3KUL_","header-row":"SimpleTable_header-row__1Wlnj","row-cell":"SimpleTable_row-cell__JETF3","extra-row":"SimpleTable_extra-row__2RuC9"};